import i18n from '../i18n';
import { VehicleStatus } from '../../../shared/types/vehicle.types';

type StatusConfig = { label: string; color: 'warning' | 'success' | 'error' | 'info' | 'default' };

export const vehicleStatusConfig: Record<VehicleStatus, StatusConfig> = {
    [VehicleStatus.Pending]: { label: i18n.t('vehicleStatus.pending'), color: 'warning' },
    [VehicleStatus.Active]: { label: i18n.t('vehicleStatus.active'), color: 'success' },
    [VehicleStatus.Rejected]: { label: i18n.t('vehicleStatus.rejected'), color: 'error' },
    [VehicleStatus.InfoRequested]: { label: i18n.t('vehicleStatus.infoRequested'), color: 'info' },
};
